import React from 'react';
import { Users } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al gimnasio con el plan exacto de la clase. El Tomo 3 es exactamente lo que necesitaba para mis grupos de nivel inicial con aro y cuerda. Nunca más improviso.',
  initials: 'VM',
  name: 'Valeria M.',
  location: 'Buenos Aires',
  role: 'INSTRUCTORA DE RÍTMICA EN CLUB DEPORTIVO'
}, {
  quote: 'El Tomo 2 de técnica corporal me cambió todo. El primer mes, alumnas que llevaban tiempo estancadas mejoraron visiblemente su postura y coordinación. Las progresiones son únicas.',
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'PROFE EN ACADEMIA PARTICULAR'
}, {
  quote: 'El sistema de progresión por aparato es único en el mercado. 10 clases listas para usar en cada aparato, con las indicaciones técnicas descriptas paso a paso. Antes tardaba horas armando una sesión. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  initials: 'SF',
  name: 'Sofía F.',
  location: 'Córdoba',
  role: 'INSTRUCTORA GRUPAL E INDIVIDUAL'
}, {
  quote: 'Las Fichas de Seguimiento del Bono 3 eliminaron mi inseguridad al evaluar a mis alumnas. Ahora sé exactamente en qué están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.',
  initials: 'LP',
  name: 'Luciana P.',
  location: 'Tucumán',
  role: 'PROFE PARTICULAR Y EN CLUB'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión por niveles. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'INSTRUCTORA DE RÍTMICA ONLINE Y PRESENCIAL'
}, {
  quote: 'El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas. Mi academia me reconoce como la instructora más organizada.',
  initials: 'LV',
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'INSTRUCTORA EN CLUB Y ACADEMIA MUNICIPAL'
}, {
  quote: 'Las Coreografías del Pack Élite me cambiaron la cabeza. Nunca había dimensionado el potencial de llegar a una exhibición con todo resuelto. Ahora trabajo con una seguridad que antes no tenía.',
  initials: 'AR',
  name: 'Ana R.',
  location: 'Salta',
  role: 'INSTRUCTORA EN CLUB Y ESPACIO PRIVADO'
}];
export function ExtendedTestimonials() {
  return <section className="py-10 md:py-20 bg-gray-50" data-id="element-82">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-83">
        <div className="text-center mb-8 md:mb-16" data-id="element-84">
          <h2 className="text-2xl md:text-5xl font-bold font-serif text-secondary-dark mb-2 md:mb-4" data-id="element-85">
            Lo que dicen las instructoras que ya lo usan
          </h2>
          <p className="text-sm md:text-xl text-gray-600 font-medium flex items-center justify-center gap-2" data-id="element-86">
            <Users className="w-5 h-5 md:w-6 md:h-6 text-primary" data-id="element-87" />
            +300 instructoras de todo el país ya tienen su Gimnasia Rítmica
            Infantil Resuelta™
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-88">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-sm border border-gray-100 relative hover:shadow-md transition-shadow" data-id="element-89">
              <div className="flex text-yellow-400 mb-2 md:mb-4 text-sm md:text-base" data-id="element-90">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-91">{star}</span>)}
              </div>
              <p className="text-sm md:text-base text-gray-700 italic mb-4 md:mb-6 relative z-10" data-id="element-92">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 md:gap-4 mt-auto pt-3 md:pt-4 border-t border-gray-50" data-id="element-93">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-light text-primary flex items-center justify-center font-bold text-sm md:text-lg flex-shrink-0" data-id="element-94">
                  {testimonial.initials}
                </div>
                <div data-id="element-95">
                  <h4 className="font-bold text-gray-900 text-sm md:text-base" data-id="element-96">
                    {testimonial.name}{' '}
                    <span className="text-gray-500 font-normal text-xs md:text-sm ml-1" data-id="element-97">
                      {testimonial.location}
                    </span>
                  </h4>
                  <p className="text-[9px] md:text-[10px] text-gray-500 font-semibold mt-0.5 md:mt-1 uppercase tracking-wider leading-tight" data-id="element-98">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}